<template>


    <div :class="`btn-group ${customClass}`" id="booking_dropdown">
        <button  v-if="viewPage" data-toggle="dropdown" class="actions-btn btn btn-default three-dots-btn gh_customer_name dropdown-toggle" style="padding: 0px !important;"
                aria-expanded="false">
            <i class="fa fa-ellipsis-v" style="color: rgb(138, 138, 138); font-size: 18px;"></i>
        </button>
        <button  v-else data-toggle="dropdown"  class="dropdown-toggle three-dots-btn pull-right">
            <i class="fa fa-ellipsis-v " style="color:rgba(138, 138, 138,1);font-size: 18px;margin-right: 2px"></i>
        </button>
        <ul class="dropdown-menu"  >


             <li class="convert-to-open" v-if="check_if_can_View_booking() ">
                 <a :href="`/booking/view/${itemObject.booking_id}`"  >
                         <span><i class="fa fa-file-text-o"></i><i class="fa fa-search search-icon"></i></span>
                     &nbsp   View booking
                 </a>
             </li>


            <li class="convert-to-open" v-if="itemType == 'inquiry'  && itemBooking.booking_num  && !itemObject.is_deleted && itemObject.status == 'booking' ">
                <a :href="`/booking/view/${itemBooking.booking_id}`"  >
                    <span><i class="fa fa-file-text-o"></i></span>
                    &nbsp   View booking
                    <b  > {{  itemBooking.booking_num  }}</b>
                </a>
            </li>


            <li v-if="check_if_can_show_edit_li()">
                <a  :href="get_url_data()" >
                    <span class="fa fa-edit"></span>  &nbsp Edit
                    <span  v-if="itemType=='booking' &&  !viewPage"> Booking</span>
                </a>
            </li>

            <li class="convert-to-open"  v-if="  !itemObject.is_deleted  &&  itemType=='inquiry' && itemObject.status == 'estimate'  &&  itemEstimate.id  " >
                 <a  :href="`/estimate/view/${itemEstimate.id}`"  class="estimateestimate" >
                    <b> {{itemEstimate.estimate_num}}  </b>&nbsp View Quote</a>
             </li>


            <li class="convert-to-open"  v-if="   !itemObject.is_deleted  &&  itemType=='inquiry' && itemObject.status == 'booking'  &&  itemInvoice &&  itemInvoice.id" >
                 <a  :href="`/invoice/view/${itemInvoice.id}`"   >
                    <b class="itemInvoiceitemInvoice"> {{ itemInvoice.invoice_num }}</b>&nbsp View invoice</a>
             </li>


            <li class="org_inquiry hidden"  v-if="  !itemObject.is_deleted  &&   itemType=='inquiry' "  >
                <a href="#" id="toggle_org_inquiry" onclick="toggle_inquiry()">
                    <span class="fa fa-inbox"></span>&nbsp Original Inquiry</a>
            </li>

            <li class="divider" v-if="   !itemObject.is_deleted  &&  itemType=='inquiry'"  ></li>

            <li class="convert-to-open"  v-if="   !itemObject.is_deleted  &&  itemType=='inquiry' && itemObject.status == 'inquiry'  && allCredentialsArray.inquiryConvertToBookingCredential" >
                 <a :href="`/inquiry/convert/booking/${itemObject.inquiry_id}`"   >
                     <span  class="fa fa-exchange"></span>&nbsp Convert To Booking</a>
             </li>


            <li class="convert-to-open"
                v-if="  !itemObject.is_deleted  &&  itemType=='inquiry' && itemObject.status == 'inquiry'  && allCredentialsArray.inquiryConvertToBookingCredential" >
                 <a  :href="`/inquiry/convert/estimate/${itemObject.inquiry_id}`"  >
                     <span class="fa fa-exchange"></span>&nbsp Convert To Quote</a>
             </li>

            <li class="divider inquiryinquiry"  v-if=" !itemObject.is_deleted  &&   itemType=='inquiry'" ></li>

            <li class="inquiryDelete " v-if="  !itemObject.is_deleted  &&  itemType=='inquiry' && allCredentialsArray.inquiryDeletecredential">
                 <a href="#"   @click="deleteLink_vue()" > <span class="fa fa-times"></span>&nbsp Delete</a>
            </li>

            <li class="inquiryDelete " v-if=" itemObject.is_deleted  &&   itemType=='inquiry' && allCredentialsArray.inquiryDeleteForevercredential">
                <a    style="color: red !important;"    onclick="deleteForeverLink();">
                    <span>  <i class="fa fa-trash-o"></i> </span> &nbsp   Delete Forever</a>

            </li>

            <li class="inquiryDelete " v-if="  itemObject.is_deleted  && itemType=='inquiry' && allCredentialsArray.inquiryUndeletecredential">
                <a    href="#"    class="unDeleteLink_vue inquiryinquiry" @click="unDeleteLink_vue()">
                    <span>  <i class="fa fa-arrow-up"></i> </span>  &nbsp  UnDelete</a>
            </li>

            <li  v-if=" !itemObject.is_deleted &&   itemType !='inquiry' " class="divider"></li>

            <li v-if="  loggedUserRole == 'contractor'  &&  itemType =='booking'  &&  !itemObject.is_deleted   &&  itemObject.not_accepted && itemObject.booking_id ">
                <a class="a_accept"  data-toggle="modal" data-target="#popupi"   href="#"
                   onclick="addClickedIdentifier(this);acceptServices_vue();"> &nbsp Accept</a>

            </li>

            <li v-if="  loggedUserRole == 'contractor'  &&  itemType =='booking'  &&  !itemObject.is_deleted    &&  itemObject.not_accepted_or_rejected && itemObject.booking_id " >
                <a class="a_reject"  data-toggle="modal" data-target="#popupi"   href="#"
                   onclick="addClickedIdentifier(this);rejectServices_vue();"> &nbsp Decline</a>

            </li>

            <li v-if="allCredentialsArray.hasinvoiceViewCredential &&  bookingInvoice && !bookingInvoice.is_deleted && !itemObject.is_deleted ">

                <a data-toggle="modal"  :data-target="`#invoice-popup${itemObject.booking_id}`" >
                    <b v-if="bookingInvoice.merged_invoice_num">  {{ bookingInvoice.merged_invoice_num }}  </b>
                    <b  class="bookingInvoicebookingInvoice" v-else  >    {{ bookingInvoice.invoice_num }}  </b> &nbsp  View Invoice
                </a>

            </li>

            <li  v-if=" check_if_can_show_repeat_booking()" class="convert-to-open" >
              <a  @click="click_repeat_booking" class="details_info_opt" href="#" data-toggle="modal" id="repeat-booking-btn" data-target="#popupi"  >
                  Create Repeat / Recurring Booking  </a>
            </li>

             <li  v-if=" itemType !='inquiry' &&  (loggedUser.role_id  != contractorRoleId || (loggedUser.role_id  == contractorRoleId && allowFieldworkerAddBooking ))  &&  hasRecurring && itemObject.status_id !=3 && !itemObject.is_deleted  " class="convert-to-open">
              <a  @click="showRepeatBookingvue"   class="details_info_opt" href="#" id="show_repeat_booking">  Delete Repeat Booking</a>
            </li>

          <li class="edit" v-if="check_if_can_Change_Quote_Number_vue_li()">
             <a href="#" data-toggle="modal" data-target="#popupi" @click="Change_Quote_Number_vue"  class="details_info_opt">
              <i class="fa fa-edit"></i>&nbsp Change Quote Number    </a>
           </li>

          <li v-if="  (loggedUser.role_id  != contractorRoleId || (loggedUser.role_id  == contractorRoleId && allowFieldworkerAddBooking ))
           &&   (status && status.name === 'QUOTED'  ) && !itemObject.is_deleted  && estimateParams ">
            <a href="#" data-toggle="modal" data-target="#popupi" @click="Preview_Quote_vue"   class="details_info_opt">
              <i class="fa fa-eye"></i>&nbsp Preview Quote
            </a>
          </li>


             <li  v-if="allCredentialsArray.hasconvertEstimateToBookingCredential &&  itemObject.convert_status == 'estimate' && !itemObject.is_deleted " class="convert-to-open">
                <a  :href="`/estimate/convert/booking/${itemObject.booking_id}`"  >
                    <i class="fa fa-exchange"></i>&nbsp Convert to Booking</a>
            </li>

          <li v-if=" itemType !='inquiry' &&   (loggedUser.role_id  != contractorRoleId || (loggedUser.role_id  == contractorRoleId && allowFieldworkerAddBooking ))
           && !itemObject.is_deleted  ">
            <a  :href="`/booking/add?duplicated_booking_id=${itemObject.booking_id}`" >
            <span class="icon1-double-booking"></span>&nbsp Duplicate This
                <span  v-if="status && status.name == 'QUOTED'   ">  Quote </span>
                <span  v-else-if="itemType">  {{ ucfirst(itemType) }} </span>

            </a>
          </li>

            <li  v-if=" isAccepted  && itemObject.convert_status != 'invoice' &&
            showBillingInfoCondition &&  !itemObject.is_free && !itemObject.is_deleted  "  class="divider">
            </li>


            <li  v-if="!itemObject.is_deleted  &&  allCredentialsArray.hasBookingDiscussionCredential  && !viewPage" class="convert-to-open">
                <a   data-toggle="modal" data-target="#popupi"   href="#"   @click="Booking_discussion_vue"  >
                    <span class="iconify" data-icon="ri-discuss-line" data-inline="false"></span>
                    <span> &nbsp Booking discussion</span>
                </a>
            </li>


            <li v-if=" itemObject.booking_id && status && status.name == 'QUOTED' ">
                <a class="details_info_opt" :id="`followUp${itemObject.booking_id}`" style="display: block" data-toggle="modal"
                   data-target="#popupi"    @click="Follow_Up_Booking_vue"  >
                <span class="iconify" data-icon="cil-library-add" data-inline="false"></span>
                <span> &nbsp Follow Up Booking</span>
                </a>

            </li>


                <li v-if="!itemObject.is_deleted  &&  allCredentialsArray.hasBookingLableCredential && !viewPage && loggedUserRole  != 'contractor' " class="convert-to-open">

                   <a data-toggle="modal" data-target="#popupi"   href="#"   @click="Add_label_vue"    class="add-border_55">
                           <span class="iconify" data-icon="cil:tag" data-inline="false"></span>
                            <span> &nbsp Add label</span>
                    </a>
                </li>

            <li  v-if="check_if_can_view_Generate_Invoice_vue()" class="convert-to-open">
                <!-- check if billing cycle setted up && multiple open cycles && let the admin choose the cycle he wants to generate the invoice into  -->

                <a v-if="hasMultipleOpenCycles" class="details_info_opt" href="#" data-toggle="modal"
                   data-target="#popupi" @click="Generate_Invoice_vue" >
                    <span   class="fa fa-exchange"></span>&nbsp Generate Invoice</a>

                <a v-else  @click="convertBookingToInvoicevue(itemObject.booking_id)" >
                    <span  class="fa fa-exchange"></span>&nbsp Generate Invoice</a>

            </li>


            <li v-if="can_show_hr_divider()" class="divider divider_5595 "></li>

            <li v-if="check_if_can_Convert_To_Quote_vue()" class="convert-to-open">
                <a  href="#" data-toggle="modal" data-target="#popupi" @click="Convert_To_Quote_vue()"  >
                    <span class="fa fa-exchange"></span>&nbsp Convert to Quote</a>
            </li>


            <li class="divider hidden"></li>

            <!-- nearest booking -->
            <li class="hidden" v-if="  !itemObject.is_deleted ">
                <a href="#" data-toggle="modal" data-target="#fn_nearest" @click="fn_popupi_with_parm_vue" >
                    <i class="glyphicon glyphicon-map-marker"></i> &nbsp  Nearest  Booking
                </a>
            </li>

            <!-- find Availability -->

            <li class="collapse more-action-options hidden" v-if="  !itemObject.is_deleted ">
                <a href="#" data-toggle="modal" data-target="#fn_nearest" @click="Find_Availabilityfn_popupi_with_parm_vue" >
                    <i class="fa fa-calendar"></i>
                    &nbsp  Find Availability
                </a>
            </li>

            <li class="divider collapse more-action-options hidden"></li>

             <li  v-if="allCredentialsArray.canAcceptAdminServicesCredential && !itemObject.is_deleted  && false " class="convert-to-open collapse more-action-options">
                <a class="details_info_opt" href="#" data-toggle="modal" data-target="#popupi" @click="Push_to_Google_Calendar" >
                    &nbsp  Push to Technician Calender</a>
             </li>

             <li  v-if="allCredentialsArray.hasdownloadBookingCredential && itemObject.status_id !=3 && !itemObject.is_deleted  " class="export-as-pdf">
                <a  :href="`/download/booking/${itemObject.booking_id}`" >
                    <i class="fa fa-external-link"></i> &nbsp Print Booking PDF</a>
             </li>

             <li v-if="allCredentialsArray.hasdownloadEstimateCredential  && itemObject.status_id == 3  && !itemObject.is_deleted  && estimateParams" class="export-as-pdf">
                <a :href="`/download/estimate/${estimateParams.id}`"  >
                    <span><i class="fa fa-external-link"></i></span>&nbsp Print Quote PDF</a>
            </li>

            <li class="make-recurring collapse more-action-options hidden" v-if="  !itemObject.is_deleted ">
                <a    :href="`/item-attachment/booking/${itemObject.booking_id}`"  class="details_info_opt">
                    <span class="fa fa-upload"></span>&nbsp Image Attachment</a>
            </li>

            <li hidden v-if="  !itemObject.is_deleted  && loggedUserRole == 'super_admin' ||   loggedUserRole == 'account_admin' " >
                <a   :href="`/bookingCacheClear/${itemObject.booking_id}`"   >
                    <span class="fa fa-times">
                </span>&nbsp Clear Cache</a>
            </li>

             <li v-if=" itemObject.is_deleted && allCredentialsArray.hasbookingUndeleteCredential">
                <a class="unDeleteBooking_vueunDeleteBooking_vue" @click="unDeleteBooking_vue()"  >
                    <span>  <i class="fa fa-arrow-up"></i> </span>  &nbsp  UnDelete</a>
            </li>

             <li v-if=" itemObject.is_deleted && allCredentialsArray.hasbookingUndeleteCredential && allCredentialsArray.DeleteForevercredential " >

                <a   style="color: red !important;"   @click="deleteForEverBooking_vue()">
                    <span>  <i class="fa fa-trash-o"></i> </span>
                    &nbsp Delete forever</a>
            </li>

            <li  v-if="(allCredentialsArray.hasbookingDeleteCredential || canDelete) && !itemObject.is_deleted " class="divider Delete_forever_55"></li>
            <li v-if="(allCredentialsArray.hasbookingDeleteCredential || canDelete ) && viewPage && !itemObject.is_deleted "  >
                <a  onclick="deleteBooking()">
                    <span class="fa fa-times"></span>&nbsp Delete
                    <span  v-if="status && status.name == 'QUOTED'   ">  Quote </span>

                    <span v-else="itemType">  {{ itemType }} </span>
                </a>
            </li>

            <li v-if="(allCredentialsArray.hasbookingDeleteCredential || canDelete ) && !viewPage && !itemObject.is_deleted  &&  itemObject.booking_num " >
                <a   @click="Delete_on_all_listing_page()" class="delete-link">
                     <span class="iconify" data-icon="fa:trash-o" data-inline="false"></span>
                    <span> &nbsp Delete</span>
               </a>
            </li>



        </ul>
    </div>



</template>

<script>

import {EventBus} from "@/events/event-bus";

export default {
    name: "viewItemDropdownAction",
    props:{
      customClass:null,
         itemObject:null,
        itemBooking:null,
        itemEstimate:null,
        itemInvoice:null,
        bookingInvoice:null,
        viewPage:null,
        loggedUser:null,
        contractorRoleId:null,
        hasRecurring:null,
        estimateData:null,
        allowFieldworkerAddBooking:null,
        status:null,
        isRepeated:null,
        parentNum:null,
        isAccepted:null,
        showBillingInfoCondition:null,
        hasMultipleOpenCycles:null,
        parentId:null,
        estimateParams:null,
        shownHorizontalLine:null,
        nearestBookingParams:null,
        findAvailabilityParams:null,
        allCredentialsArray:null,
        canDelete:null,
        loggedUserRole:null,
        itemType:null,

    },

    data(){
      return {
          estimateStatus:  null
      }
    },

    methods:{

        deleteForEverBooking_vue(){
             if(this.viewPage){
                window.deleteForEverBooking();
            }else {
                 window.deleteForEver( this.itemObject.booking_id , this.itemObject.booking_num );
            }
        },

        check_if_can_view_Generate_Invoice_vue(){
            return this.allCredentialsArray.hasconvertBookingToInvoiceCredential && this.isAccepted  && this.itemObject.convert_status != 'invoice' &&
                this.showBillingInfoCondition &&  !this.itemObject.is_free && !this.itemObject.is_deleted  &&  ( !this.bookingInvoice) ;
        },
        unDeleteBooking_vue(){

            if(this.viewPage){
                window.unDeleteBooking();
            }else {
                window.unDelete( this.itemObject.booking_id , this.itemObject.booking_num );
            }
        },
        deleteLink_vue(){
        window.deleteLink();
        },
        unDeleteLink_vue(){
         window.unDeleteLink();
        },
        check_if_can_show_repeat_booking(){
            return  this.viewPage &&   this.itemType !='inquiry' &&  (this.loggedUser?.role_id  != this.contractorRoleId || (this.loggedUser.role_id  == this.contractorRoleId && this.allowFieldworkerAddBooking ))  && this.itemObject.status_id !=3 && !this.itemObject.is_deleted ;
        },
        can_show_hr_divider(){
            return   (this.allCredentialsArray.hasconvertBookingToEstimateCredential && this.isAccepted  && this.itemObject.convert_status != 'estimate'
                && this.itemObject.convert_status != 'invoice' && this.showBillingInfoCondition  ) && !this.shownHorizontalLine && !this.itemObject.is_deleted ;
        },
        check_if_can_View_booking() {

         if (!this.viewPage && this.itemType == 'booking'  && this.itemObject.booking_num) {
                return  1 ;
            }else {
                return  0;
            }
        } ,
        get_url_data(){
               if(this.itemType=='booking'){
                    return `/booking/edit/${this.itemObject.booking_id}`;
                }else if(this.itemType=='inquiry'){
                   return `/inquiry/edit/${this.itemObject.inquiry_id}`;
             }
            },
        check_if_can_show_edit_li(){

             if(this.itemType=='booking'){

                 return  ( this.allCredentialsArray.hasbookingEditCredential  )

             }else if(this.itemType=='inquiry'){

                 return  ( ( this.allCredentialsArray.inquiryEditCredential  &&   this.allCredentialsArray.inquiryConvertToBookingCredential
                         &&  this.allCredentialsArray.inquiryConvertToEstimateCredential   &&  this.allCredentialsArray.inquiryLabelredential )
                     && !this.itemObject.is_deleted  && this.itemObject.status == 'inquiry' )
             }

        },
        ucfirst(str) {
              if (!str) return str; // Return the original string if it's empty
              return str.charAt(0).toUpperCase() + str.slice(1);
            },
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
        click_repeat_booking (){

         if(this.isRepeated == '1'){
              var url_click_repeat_booking=`/booking/view/${this.parentId}`;
              var text_data = `This booking belongs to a repeat booking group and can't be repeated. If you want to repeat this booking you can do it from the original parent booking
                        <a href="${url_click_repeat_booking}">   ${this.parentNum} </a> or you can create a new booking separately and then repeat it.`;
              window.popupi_alert('Notice',text_data);
          }else{
             var action_url = `/recurringbooking/${this.itemObject.booking_id}`;
            window.popupi('Repeat Booking',  action_url);
          }


      },
        Change_Quote_Number_vue (){

             var action_url = `/estimate/edit-estimate-number/${this.estimateParams.id}`;
            window.popupi('Edit Quote Number',  action_url);

      },
        acceptServices_vue (){

            var action_url = `/dashboard/acceptServices/${this.itemObject.booking_id}`;
            window.popupi('Accept ',  action_url);

      },
        rejectServices_vue (){
            var action_url = `/dashboard/rejectServices/${this.itemObject.booking_id}`;
            window.popupi('Decline ',  action_url);

      },
        check_if_can_Change_Quote_Number_vue_li (){
            return (this.loggedUser.role_id  != this.contractorRoleId || (this.loggedUser?.role_id  == this.contractorRoleId && this.allowFieldworkerAddBooking  ))
                &&   (this.status && this.status.name == 'QUOTED' )  && this.allCredentialsArray.hasEditEstimateNumberCredential  && this.estimateData && this.estimateData.isAccepted
                && !this.itemObject.is_deleted ;
        },
        Push_to_Google_Calendar (){
              var action_url = `/dashboard/resendAdminServices/${this.itemObject.booking_id}`;
            window.popupi(' Push to Google Calendar ',  action_url);
      },
        Add_label_vue (){
            var action_url = `/booking/label/select-label/${this.itemObject.booking_id}?color=1`;
            window.popupi('Booking Label',  action_url);
      },
        Preview_Quote_vue (){
              var action_url = `/estimate/preview/${this.estimateParams.id}`;
            window.popupi('Quote Preview',  action_url);

      },
        Booking_discussion_vue(){
             var action_url = `/booking/discussion/${this.itemObject.booking_id}/send/booking/`;
            window.popupi('Booking Discussion',  action_url);
        },
        Follow_Up_Booking_vue(){

             var action_url = `/follow-up/${this.itemObject.booking_id}?type=booking`;
            window.popupi('Follow up date',  action_url);
        },
        Generate_Invoice_vue (){
               var action_url = `/booking/get-billing-cycle/${this.itemObject.booking_id}`;
            window.popupi(' Select Open Cycle  ',  action_url);

      },
        Convert_To_Quote_vue (){
             var action_url = `/booking/convert/estimate/${this.itemObject.booking_id}`;
            window.popupi('Convert To Quote',  action_url);

        },
        check_if_can_Convert_To_Quote_vue (){
            return this.allCredentialsArray.hasconvertBookingToEstimateCredential && this.isAccepted
                && this.itemObject.convert_status != 'estimate'    && this.itemObject.convert_status != 'invoice' &&  this.itemType !='booking'
                && this.showBillingInfoCondition && !this.itemObject.is_deleted && (this.status && this.status.name != 'QUOTED' ) ;

        },
        fn_popupi_with_parm_vue (){
            var nearbyBookingsMap_url = `/ajax/nearbyBookingsMap/`;
              window.fn_popupi_with_parm('Nearest bookings', nearbyBookingsMap_url, this.nearestBookingParams);

        },
        Delete_on_all_listing_page (){

               window.deleteLink(`${ this.itemObject.booking_id}` , `${ this.itemObject.booking_num}`);

        },
        Find_Availabilityfn_popupi_with_parm_vue (){

            var Availability_url = `/ajax/findAvailability/`;
            window.fn_popupi_with_parm('Find Availability', Availability_url, this.findAvailabilityParams);

        },
        showRepeatBookingvue(){
              window.showRepeatBooking();
          },
        convertBookingToInvoicevue(booking_id){
              window.convertBookingToInvoice(booking_id);
           },
        lestinConvertBookingToInvoice(){
            EventBus.$on('convertBookingToInvoiceEvent', (data) => {
                this.itemObject.convert_status = "invoice";
                this.bookingInvoice = data;
            })
        }

},
  mounted() {
      this.lestinConvertBookingToInvoice()
    }
}
</script>

<style scoped>
button.actions-btn.btn.btn-default.three-dots-btn.gh_customer_name.dropdown-toggle {
  border:1px solid #ccc !important;
}
@media screen and (max-width: 991px) {
  .three-dots-container-position .dropdown-menu{
    right: -150px;
  }
}
</style>